export const EVENT_TYPES = [
    'selected',
    'deselected',
    'history',
    'moveEnd',
    'load',
    'reset',
    'modelLoaded',
    'allModelsLoaded',
    'loadLegacyShoppingItems',
    'loadVpc',
    'loadVpcFailure',
    'loadVpcSuccess',
    'update',
    'conflict',
    'moving',
    'walls',
    'roomSize',
    'saveVpcStart',
    'saveVpcComplete',
    'solutionUpdateInProgress',
    'solutionUpdateDone',
    'unavailableProductsUpdated',
    'inScene',
    'undo',
    'redo',
    'duplicate',
    'helpLinesUpdated',
    'helpLinesConflictsResolved',
    'helpLinesShapeResizeFinished',
    'helpLinesShapeResize',
    'helpLinesShapeChange',
    'proppingAgeGroupUpdated',
    'loadWallShapeFromVpc',
    'tooManyLightsAdded',
    'enableNightMode',
    'placementAttempt',
    'saveDesignId',
    'loadDesignId'
];
export var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["NoFramesInScene"] = "NoFramesInScene";
    ErrorMessages["NoDoorsInScene"] = "NoDoorsInScene";
    ErrorMessages["ItemWontFit"] = "ItemWontFit";
    ErrorMessages["LegsWontFit"] = "LegsWontFit";
    ErrorMessages["HandlesTooBigForDoor"] = "HandlesTooBigForDoor";
    ErrorMessages["PaxSlidingDoorOnCorner"] = "PaxSlidingDoorOnCorner";
    ErrorMessages["PaxCornerFrameOpenCombination"] = "PaxCornerFrameOpenCombination";
    ErrorMessages["PaxDoorAppliedButNotFittingCorner"] = "PaxDoorAppliedButNotFittingCorner";
    ErrorMessages["PaxDoorHandlesOnCornerSolution"] = "PaxDoorHandlesOnCornerSolution";
    ErrorMessages["PaxDoorHandlesOnSlidingDoors"] = "PaxDoorHandlesOnSlidingDoors";
    ErrorMessages["PaxDoorHandlesOnDoorsIntegratedHandles"] = "PaxDoorHandlesOnDoorsIntegratedHandles";
    ErrorMessages["PaxDoorHandlesOnDoorsMixedIncludedIntegratedHandles"] = "PaxDoorHandlesOnDoorsMixedIncludedIntegratedHandles";
    ErrorMessages["PaxSlidingDoorApplicableOnSomeFrames"] = "PaxSlidingDoorApplicableOnSomeFrames";
    ErrorMessages["NoRoomForOuterLights"] = "NoRoomForOuterLights";
    ErrorMessages["AddingEketToBestaFrames"] = "AddingEketToBestaFrames";
    ErrorMessages["AddingBestaToEketFrames"] = "AddingBestaToEketFrames";
    ErrorMessages["AddingToMixedBestaEketFrames"] = "AddingToMixedBestaEketFrames";
    ErrorMessages["AddingLightsToBestaSolidDoors"] = "AddingLightsToBestaSolidDoors";
    ErrorMessages["AddingLightsToBestaMixedDoors"] = "AddingLightsToBestaMixedDoors";
    ErrorMessages["AddingBestaTopPanelNoMatchingFrames"] = "AddingBestaTopPanelNoMatchingFrames";
    ErrorMessages["PlatsaSlidingDoorsNotPossible"] = "PlatsaSlidingDoorsNotPossible";
    ErrorMessages["PlatsaAddingDoorsToOpenFrames"] = "PlatsaAddingDoorsToOpenFrames";
    ErrorMessages["PlatsaAddingHandlesToOpenFrames"] = "PlatsaAddingHandlesToOpenFrames";
    ErrorMessages["PlatsaClothRailCollision"] = "PlatsaClothRailCollision";
    ErrorMessages["SmastadAddingToFramesWithIncludedDoors"] = "SmastadAddingToFramesWithIncludedDoors";
    ErrorMessages["SmastadAddingToMixedFramesWithIncludedDoors"] = "SmastadAddingToMixedFramesWithIncludedDoors";
    ErrorMessages["SmastadAddingToPullOutFrames"] = "SmastadAddingToPullOutFrames";
    ErrorMessages["SmastadAddingToMixedPullOutFrames"] = "SmastadAddingToMixedPullOutFrames";
    ErrorMessages["IvarAddingDeskTo50DepthFrame"] = "IvarAddingDeskTo50DepthFrame";
    ErrorMessages["IvarAddingDrawerWontFit"] = "IvarAddingDrawerWontFit";
    ErrorMessages["BrorAddingWallSystemInteriorToRegularFrame"] = "BrorAddingWallSystemInteriorToRegularFrame";
    ErrorMessages["BrorAddingRegularInteriorToWallSystemFrame"] = "BrorAddingRegularInteriorToWallSystemFrame";
    ErrorMessages["BrorNoMatchingFramesForCabinets"] = "BrorNoMatchingFramesForCabinets";
    ErrorMessages["BrorNoMatchingFramesForDrawers"] = "BrorNoMatchingFramesForDrawers";
    ErrorMessages["BillyExtensionWontFit"] = "BillyExtensionWontFit";
    ErrorMessages["BillyCornerFrameNoDoors"] = "BillyCornerFrameNoDoors";
    ErrorMessages["BillyExtensionMaxTwo"] = "BillyExtensionMaxTwo";
    ErrorMessages["BillyExtensionSmallFrame"] = "BillyExtensionSmallFrame";
    ErrorMessages["BillyMoveFrameToCornerDeleteExtAndDoor"] = "BillyMoveFrameToCornerDeleteExtAndDoor";
    ErrorMessages["BillyInteriorCollidesWithDoor"] = "BillyInteriorCollidesWithDoor";
    ErrorMessages["ChangeColorMissingFramesMessage"] = "changeColorMissingFramesMessage";
    ErrorMessages["BestaTopPanelsAbove150Message"] = "BestaTopPanelsAbove150Message";
    ErrorMessages["BestaTopPanelsNotAddedToSomeFramesMessage"] = "BestaTopPanelsNotAddedToSomeFramesMessage";
    ErrorMessages["LadmakareInteriorOnWideFramesOnly"] = "LadmakareInteriorOnWideFramesOnly";
    ErrorMessages["SmastadExteriorAccessoryOnDoorsOnly"] = "SmastadExteriorAccessoryOnDoorsOnly";
    ErrorMessages["LadmakareCabinetBlockedByOtherCabinet"] = "LadmakareCabinetBlockedByOtherCabinet";
    ErrorMessages["BoaxelClothesRailRequiresShelf"] = "BoaxelClothesRailRequiresShelf";
})(ErrorMessages || (ErrorMessages = {}));
export const CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY = 'adjustable-cloth-rail-outside-right-';
export const CLOTH_RAIL_INSIDE_CONNECTOR_KEY = 'adjustable-cloth-rail-inside-left-';
export const CLOTH_RAIL_LEFT_FRAME_CONNECTOR_KEY = 'frame-connector-left';
export const CLOTH_RAIL_RIGHT_FRAME_CONNECTOR_KEY = 'adjustable-connector';
export const CLOTH_RAIL_ALIGN_SERIES_LEFT = 'align-point-series-left-';
export const CLOTH_RAIL_ALIGN_SERIES_RIGHT = 'align-point-series-right-';
//# sourceMappingURL=types.js.map